import React, { useState, useEffect, useRef } from 'react';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const mobileMenuRef = useRef(null);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Handle Escape key to close mobile menu
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isOpen) {
        setIsOpen(false);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen]);

  // Focus first menu item when menu opens
  useEffect(() => {
    if (isOpen && mobileMenuRef.current) {
      const firstMenuItem = mobileMenuRef.current.querySelector('a');
      firstMenuItem?.focus();
    }
  }, [isOpen]);

  // Hamburger Menu Icon (SVG)
  const MenuIcon = () => (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
    </svg>
  );

  // Close Icon (SVG)
  const CloseIcon = () => (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
  );

  return (
    <header className="bg-white text-black font-bold-montserrat font-extrabold p-4 shadow-md w-full relative">
      <div className="container mx-auto flex justify-between items-center">
        <div className="flex items-center h-auto w-[150px] sm:w-[200px] overflow-hidden">
          <a href="/">
            <img src="/Logo_CPS.png" alt="PT. CPS Logo" className="h-10 sm:h-12 w-auto ml-0 sm:ml-4" />
          </a>
        </div>

        {/* Spacer to push the nav links to the center */}
        <div className="flex-grow"></div>

        {/* Desktop Navigation links */}
        <nav className="hidden lg:flex items-center space-x-4 font-bold-montserrat font-extrabold">
          <a href="/" className="text-black px-4 py-2 rounded-md hover:bg-blue-100 font-extrabold">HOME</a>
          <a href="/about" className="text-black px-4 py-2 rounded-md hover:bg-blue-100 font-extrabold">ABOUT US</a>
          <a href="/products" className="text-black px-4 py-2 rounded-md hover:bg-blue-100 font-extrabold">OUR PRODUCTS</a>
          <a href="/contact-us" className="text-black px-4 py-2 rounded-md hover:bg-blue-100 font-extrabold">CONTACT US</a>
        </nav>

        {/* Spacer to balance the navigation */}
        <div className="flex-grow"></div>

        {/* Quotation Icon and Hamburger Menu */}
        <div className="flex items-center justify-end h-[48px] w-[150px] sm:w-[200px]">
          {!isOpen && (
            <a href="/request-quote" className="text-black px-4 py-2 rounded-md hover:bg-blue-100 font-bold hidden lg:inline-block">
              <img src="/rfq-2.png" alt="Quotation" className="h-8 w-auto mx-auto" />
            </a>
          )}
          <button
            className="lg:hidden mr-0 sm:mr-4"
            onClick={toggleMenu}
            aria-label={isOpen ? "Close menu" : "Open menu"}
            aria-expanded={isOpen}
            aria-controls="mobile-menu"
          >
            {isOpen ? <CloseIcon /> : <MenuIcon />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation Dropdown with animation */}
      <div
        className={`lg:hidden absolute top-full left-0 right-0 transition-all duration-900 ease-in-out ${
          isOpen ? 'opacity-100 max-h-96 z-50' : 'opacity-0 max-h-0 pointer-events-none z-0'
        }`}
      >
        <nav
          ref={mobileMenuRef}
          id="mobile-menu"
          className="bg-white w-full"
          aria-label="Mobile navigation"
        >
          <a href="/" className="block text-customIndigo px-4 py-3 font-extrabold border-b border-gray-300">HOME</a>
          <a href="/about" className="block text-customIndigo px-4 py-3 font-extrabold border-b border-gray-300">ABOUT US</a>
          <a href="/products" className="block text-customIndigo px-4 py-3 font-extrabold border-b border-gray-300">OUR PRODUCTS</a>
          <a href="/contact-us" className="block text-customIndigo px-4 py-3 font-extrabold border-b border-gray-300">CONTACT US</a>
          <a href="/request-quote" className="block text-customIndigo px-4 py-3 font-extrabold border-b border-gray-300">REQUEST QUOTE</a>
        </nav>
      </div>
    </header>
  );
};

export default Header;